import { useEffect, useRef } from 'react'

/**
 * Перечитать данные, когда автор вернулся на вкладку студии.
 *
 * Возврат фокуса — единственный момент, который студия видит наверняка, когда данные
 * меняли ВНЕ неё: оплата в соседней вкладке (баланс кредитов, §7), правка курса или
 * статьи через MCP или вторую вкладку (черновик модерации, `ModerationPoller`).
 *
 * Слушателя два: `focus` не приходит, если вкладку переключили без фокуса
 * окна, а `visibilitychange` стреляет и на уход — отсюда проверка
 * `visibilityState`.
 *
 * Обработчик читается из рефа: `refresh` пересоздаётся каждый рендер, и без
 * рефа подписка переставлялась бы на каждый тик опроса.
 */
export const useRefreshOnFocus = (isActive: boolean, refresh: () => void): void => {
  const latest = useRef(refresh)
  latest.current = refresh

  useEffect(() => {
    if (!isActive) return
    const onReturn = () => {
      if (document.visibilityState === 'visible') latest.current()
    }
    window.addEventListener('focus', onReturn)
    document.addEventListener('visibilitychange', onReturn)
    return () => {
      window.removeEventListener('focus', onReturn)
      document.removeEventListener('visibilitychange', onReturn)
    }
  }, [isActive])
}
